/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/

if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

/*************
 Product Card
 **************/

document.querySelectorAll('.productCardBottomATC')?.forEach(button => {
    button.addEventListener('click', async function () {
        // add loading
        this.classList.add('loading');
        // get id
        const id = this.closest('.productCard')?.querySelector('.productCardSelectorItem.active')?.dataset.id;
        if (!id) return;
        // formdata
        let formData = {quantity: 1, id: id};
        // add
        await addProduct(formData);
        // remove loading
        this.classList.remove('loading');
        // open cart
        await openCart();
    })
})

document.querySelectorAll('.productCardSelectorItem.cursor')?.forEach(el => {
    el.addEventListener('click', function () {
        if (this.classList.contains('active')) return;
        const parent = this.closest('.productCard');
        parent.querySelector('.productCardSelectorItem.active').classList.remove('active');
        this.classList.add('active');
        // show image of companion product
        parent.querySelector('.productCardImage.companion.active')?.classList.remove('active');
        parent.querySelector(`.productCardImage.companion[data-id="${this.dataset.id}"]`)?.classList.add('active');
        parent.querySelector('.productCardModel.variant.active')?.classList.remove('active');
        parent.querySelector(`.productCardModel.variant[data-id="${this.dataset.id}"]`)?.classList.add('active');
        // update card url
        parent.querySelector('.productCardLink').href = this.dataset.url;
        // update the atc button if oos (preserve span + icon markup)
        const atcBtn = parent.querySelector('.productCardBottomATC');
        const atcLabel = atcBtn.querySelector('span');
        if (this?.dataset?.available === "true") {
            atcBtn.disabled = false;
            if (atcLabel) atcLabel.textContent = "Add to cart";
        } else {
            atcBtn.disabled = true;
            if (atcLabel) atcLabel.textContent = "Sold out";
        }
    })
})


/************************* Geo-redirect *****************************/


// country code to domain hostname
let countryToDomain = {
    "US": "tabs.co",
    "AU": "au.tabs.co",
    "CA": "ca.tabs.co",
    "MX": "mx.tabs.co",
    "GB": "uk.tabs.co",
    // EU countries
    "AT": "eu.tabs.co",
    "BE": "eu.tabs.co",
    "BG": "eu.tabs.co",
    "HR": "eu.tabs.co",
    "CY": "eu.tabs.co",
    "CZ": "eu.tabs.co",
    "DK": "eu.tabs.co",
    "EE": "eu.tabs.co",
    "FI": "eu.tabs.co",
    "FR": "eu.tabs.co",
    "DE": "eu.tabs.co",
    "GR": "eu.tabs.co",
    "HU": "eu.tabs.co",
    "IS": "eu.tabs.co",
    "IE": "eu.tabs.co",
    "IT": "eu.tabs.co",
    "LV": "eu.tabs.co",
    "LT": "eu.tabs.co",
    "LU": "eu.tabs.co",
    "MT": "eu.tabs.co",
    "NL": "eu.tabs.co",
    "PL": "eu.tabs.co",
    "PT": "eu.tabs.co",
    "RO": "eu.tabs.co",
    "SK": "eu.tabs.co",
    "SI": "eu.tabs.co",
    "ES": "eu.tabs.co",
    "SE": "eu.tabs.co",
}

// check if we have never auto redirected before
if (localStorage.getItem("auto_redirected") === null) {
    fetch("https://geoip.maltertech.com")
        .then(response => response.json())
        .then(data => {
            // save geoip data
            const geoip = data;


            // if this country is in the countryToDomain and there is a mix match
            if (countryToDomain[geoip.country_code] && countryToDomain[geoip.country_code] !== window.location.hostname) {
                // prevent auto-redirect more than once
                localStorage.setItem("auto_redirected", "true");

                // update domain and redirect
                window.location.href = `https://${countryToDomain[geoip.country_code]}/${window.location.search}`;
            }
        });
}
